// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Icon } from '../../../../assets/svg/reset-arrow.svg';
import { __ } from '../../../../i18n/l10n';
import type { ClearChecksType } from '../../types/actions';

const StyledButton = styled.button`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 3em;
    background: none;
    padding: 0;
    text-align: left;
    border: none;
  }
`;

const StyledIcon = styled(Icon)`
  width: 2.2em;
  height: 2.2em;
  margin: 0 0.4em 0 0;
  fill: none;
  overflow: visible;
  stroke: ${({ $isHighlight, theme }) => ($isHighlight ? theme.grids.colors.redlight : theme.grids.colors.middlegrey3)};
`;

const Span = styled.span`
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type GridsResetSelectionProps = {
  className?: string;
  clearChecks: ClearChecksType;
  isHighlight: boolean;
};

const GridsResetSelection = ({ className, clearChecks, isHighlight }: GridsResetSelectionProps) => {
  return (
    <StyledButton className={className} onClick={clearChecks} data-testid="grid-reset-button">
      <StyledIcon $isHighlight={isHighlight} />
      <Span>{__('Reset the grid')}</Span>
    </StyledButton>
  );
};

export default GridsResetSelection;
